import React, { useState, useEffect } from 'react';
import Header from '../Utility/Components/Header'
import Footer from '../Utility/Components/Footer'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Utility/Components/Sidebar';
// import NotFoundPage from '../Utility/Pages/NotFound';


const AuthLayout = (props) => {

  const navigate = useNavigate();
  const { userDetails, token } = useSelector((state) => state.user);
  const language = useSelector((state) => state.language.language);

  console.log("userDetailsuserDetailsuserDetails",userDetails)

  useEffect(() => {
    console.log(userDetails);
    checkForUserCredential();
  }, []);

  const checkForUserCredential = () => {
    if (userDetails && typeof userDetails === 'object' && Object.keys(userDetails).length === 0) {
      navigate(`/${language}/login`);
    }

  }

  return (
    <>
      <div className="after-login">
        <Header />
        <Sidebar />
        
        {props.children}
        
        <Footer />
      </div>
    </>
  );

}


export default AuthLayout;